import { useEffect, useState } from "react";
import { api, errMsg, FRAMEWORK_META } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/shared";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

export default function AdminFrameworks() {
  const { tenantId, tenant, reload } = useAuth();
  const [rows, setRows] = useState([]);

  const load = () => {
    if (!tenantId) return;
    api.get(`/tenants/${tenantId}/framework-activations`).then(({ data }) => setRows(data)).catch((e) => toast.error(errMsg(e)));
  };
  useEffect(load, [tenantId]); // eslint-disable-line

  const toggle = async (fw, active) => {
    try {
      await api.put(`/tenants/${tenantId}/framework-activations/${fw}`, { active });
      toast.success(`${FRAMEWORK_META[fw].name} ${active ? "activated" : "deactivated"}`);
      load();
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  const setPeriodicity = async (fw, periodicity, active) => {
    try {
      await api.put(`/tenants/${tenantId}/framework-activations/${fw}`, { active, periodicity });
      toast.success(`${FRAMEWORK_META[fw].name} survey set to ${periodicity.replace("_", "-")}`);
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };


  return (
    <div className="space-y-10">
      <PageHeader
        testid="admin-frameworks-header"        eyebrow="Administration"
        title="Framework activation"
        description={`Framework access is independent of role. ${tenant?.name || "This engagement"} only exposes what is activated here AND granted per user.`}
      />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6" data-testid="framework-activation-list">
        {["panchatanthra", "viveka_kartha", "dinacharya"].map((fw) => {
          const row = rows.find((r) => r.framework === fw);
          return (
            <div key={fw} className="panel h-full p-6">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-display text-2xl">{FRAMEWORK_META[fw].name}</h3>
                  <p className="mt-3 text-sm text-muted-foreground">{FRAMEWORK_META[fw].tagline}</p>
                </div>
                <Switch
                  data-testid={`framework-toggle-${fw}`}
                  checked={!!row?.active}
                  onCheckedChange={(v) => toggle(fw, v)}
                />
              </div>
              <p className="label-caps mt-6">{row?.active ? `Active · ${row.mode || "operational"}` : "Not activated"}</p>
              {["panchatanthra", "viveka_kartha"].includes(fw) && (
                <div className="mt-4 space-y-2 border-t border-border pt-4">
                  <p className="label-caps">Survey periodicity</p>
                  <select
                    data-testid={`framework-periodicity-${fw}`}
                    value={row?.periodicity || "monthly"}
                    onChange={(e) => setPeriodicity(fw, e.target.value, !!row?.active)}
                    className="h-9 w-full rounded-md border border-border bg-card px-3 text-xs text-navy"
                  >
                    <option value="monthly">Monthly</option>
                    <option value="quarterly">Quarterly</option>
                    <option value="half_yearly">Half-yearly</option>
                    <option value="annual">Annual</option>
                  </select>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
